import { render, staticRenderFns } from "./ClientCardAdd.vue?vue&type=template&id=e53cb8f0&"
import script from "./ClientCardAdd.vue?vue&type=script&lang=js&"
export * from "./ClientCardAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports